import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {ActionsRow, DetailValue, modal} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {Button, ButtonToolbar, Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import * as subjektActions from "../actions/subjektActions";
import SpolecnostForm from "../forms/SpolecnostForm";
import SubjektApi from "../api/gen/cgo/SubjektApi";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Panel zobrazující základní údaje o společnosti.
 */
class SpolecnostZakladniUdajePanel extends Component<WithTranslation> {

    static propTypes = {
        spolecnost: PropTypes.object.isRequired, // VO společnosti
        readOnly: PropTypes.bool, // zda bude panel read only, implicitně true
    };

    static defaultProps = {
        readOnly: true,
    };

    handleEditSpolecnost = () => {
        const {spolecnost, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            SpolecnostForm,
            {
                onSubmit: (data) => {
                    return SubjektApi.updateSpolecnost(data, data.id);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(subjektActions.invalidateSpolecnostDetail(spolecnost.id));
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: spolecnost
            },
            t('company_edit'),
            {size: "md"}
        ));
    };

    renderActions = () => {
        const {t} = this.props;
        return <ButtonToolbar>
            <Button onClick={this.handleEditSpolecnost}>{t('edit')}</Button>
        </ButtonToolbar>
    };

    render() {
        const {spolecnost, readOnly, t} = this.props;
        return <Card className="spolecnost-zakladni-udaje-panel">
            <CardHeader>
                <ActionsRow actions={!readOnly ? this.renderActions() : null}>
                    <h2>{t('basic_details')}</h2>
                </ActionsRow>
            </CardHeader>
            <CardBody>
                <Row>
                    <Col xs={3}>
                        <DetailValue textOverflow label={t('cin')}>{spolecnost.ic}</DetailValue>
                    </Col>
                    <Col xs={3}>
                        <DetailValue textOverflow label={t('vatin')}>{spolecnost.dic}</DetailValue>
                    </Col>
                    <Col xs={3}>
                        <DetailValue textOverflow label={t('email')}>{spolecnost.email}</DetailValue>
                    </Col>
                    <Col xs={3}>
                        <DetailValue textOverflow label={t('phone')}>{spolecnost.telefon}</DetailValue>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    }
}

export default connect()(withTranslation()(SpolecnostZakladniUdajePanel));
